export const createEmptyCompanyRevenueRange = () => ({
    min: null,
    max: null,
    string: '',
});
export const createEmptyCompany = (id = '') => ({
    id,
    name: '',
    hasCompany: false,
    city: '',
    region: '',
    country: '',
    country_iso2: '',
    state: '',
    min: 0,
    max: 0,
    about: '',
    logoUrl: '',
    domain: '',
    homePageUrl: '',
    founded: '',
    mainIndustry: '',
    mainIndustryId: null,
    mainIndustryKey: '',
    subIndustry: '',
    facebook: '',
    twitter: '',
    LinkedIn: '',
    isSocial: false,
    companyResultString: '',
    revenueRange: createEmptyCompanyRevenueRange(),
    companyLid: null,
    companyLids: [],
    lushaCompanyId: null,
    isBlockedForShow: false,
    topics: [],
    fundingSummary: null,
    specialities: [],
    listId: null,
    metadata: null,
});
